export default __webpack_public_path__ + "static/media/ellipsis.600ae693.svg";